import { VoohTargetRealization } from '../../../../types/campaign'

export interface VoohCampaignRealization {
  chartData: VoohImpressions[]
  filters: VoohImpressionsFilters
  targetRealization: VoohTargetRealization | null
  loading: boolean
  fetchedChartData: boolean
}

export interface VoohImpressions {
  day: string
  impressions: number
  cumulativeImpressions: number
}

export interface VoohImpressionsFilters {
  agglomerations: VoohImpressionsFilterItem[]
  brands: VoohImpressionsFilterItem[]
  cities: VoohImpressionsFilterItem[]
  creations: VoohImpressionsFilterItem[]
  network: VoohImpressionsFilterItem[]
  media: VoohImpressionsFilterItem[]
}

export interface VoohImpressionsFilterItem {
  key: string
  value: string
  active: boolean
  selected: boolean
}

export const VoohCampaignRealizationSliceEmpty: VoohCampaignRealization = {
  chartData: [],
  filters: {
    agglomerations: [],
    brands: [],
    network: [],
    cities: [],
    creations: [],
    media: [],
  },
  targetRealization: null,
  loading: false,
  fetchedChartData: false,
}
